// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OneStopExecution_wrapper__GQUHI","column":"OneStopExecution_column__qJ6up"};